var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7ExternalSpeakerSystem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M862.058 500.751C862.058 514.421 850.977 525.503 837.307 525.503C823.637 525.503 812.555 514.421 812.555 500.751C812.555 487.081 823.637 476 837.307 476C850.977 476 862.058 487.081 862.058 500.751Z",
    fill: "url(#paint0_linear_1989_6328)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M850.558 502.802C846.834 513.439 836.245 519.411 826.907 516.141C817.57 512.872 813.019 501.599 816.743 490.963C820.467 480.327 831.055 474.355 840.393 477.624C849.731 480.894 854.282 492.166 850.558 502.802Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M848.747 501.078C845.411 510.605 835.926 515.955 827.561 513.026C819.196 510.098 815.12 500 818.456 490.472C821.792 480.944 831.277 475.594 839.642 478.523C848.006 481.452 852.083 491.55 848.747 501.078Z",
    fill: "url(#paint1_linear_1989_6328)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M841.874 497.031C840.203 501.806 835.449 504.487 831.258 503.019C827.066 501.551 825.023 496.491 826.695 491.717C828.367 486.942 833.12 484.262 837.311 485.729C841.503 487.197 843.546 492.257 841.874 497.031Z",
    fill: "url(#paint2_linear_1989_6328)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M836.978 486.682C833.425 485.439 829.178 487.682 827.648 492.05C826.119 496.419 828.039 500.822 831.592 502.065C835.144 503.309 839.391 501.066 840.921 496.697C842.45 492.329 840.53 487.926 836.978 486.682ZM825.741 491.383C827.555 486.202 832.814 483.084 837.645 484.775C842.476 486.467 844.642 492.184 842.828 497.365C841.014 502.546 835.755 505.664 830.924 503.972C826.093 502.281 823.928 496.563 825.741 491.383Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M839.265 491.081C838.988 492.59 837.095 493.507 835.037 493.129C832.979 492.75 831.535 491.221 831.812 489.712C832.09 488.202 833.983 487.285 836.041 487.664C838.098 488.042 839.542 489.571 839.265 491.081Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M839.042 490.05C838.92 490.711 838.091 491.112 837.19 490.947C836.289 490.781 835.657 490.111 835.778 489.45C835.899 488.789 836.728 488.388 837.63 488.553C838.531 488.719 839.163 489.389 839.042 490.05Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M533 500.752C533 514.421 544.069 525.503 557.724 525.503C571.378 525.503 582.447 514.421 582.447 500.752C582.447 487.082 571.378 476 557.724 476C544.069 476 533 487.082 533 500.752Z",
    fill: "url(#paint3_linear_1989_6328)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M544.487 502.802C548.207 513.439 558.784 519.411 568.111 516.141C577.438 512.872 581.984 501.599 578.264 490.963C574.544 480.327 563.968 474.355 554.64 477.624C545.313 480.894 540.767 492.166 544.487 502.802Z",
    fill: "#3D3D3D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M546.296 501.077C549.628 510.605 559.103 515.955 567.458 513.026C575.814 510.097 579.886 499.999 576.554 490.471C573.221 480.944 563.747 475.594 555.391 478.523C547.036 481.451 542.964 491.549 546.296 501.077Z",
    fill: "url(#paint4_linear_1989_6328)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M553.161 497.031C554.831 501.805 559.579 504.486 563.766 503.019C567.953 501.551 569.994 496.491 568.324 491.716C566.654 486.942 561.906 484.261 557.719 485.729C553.532 487.196 551.492 492.256 553.161 497.031Z",
    fill: "url(#paint5_linear_1989_6328)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.052 486.682C561.6 485.439 565.843 487.682 567.371 492.05C568.899 496.419 566.98 500.822 563.432 502.065C559.884 503.309 555.641 501.066 554.113 496.697C552.586 492.329 554.504 487.926 558.052 486.682ZM569.276 491.383C567.464 486.202 562.211 483.084 557.385 484.775C552.56 486.467 550.397 492.184 552.209 497.365C554.02 502.546 559.273 505.664 564.099 503.972C568.925 502.281 571.088 496.563 569.276 491.383Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M555.768 491.081C556.045 492.59 557.936 493.507 559.991 493.129C562.047 492.75 563.489 491.221 563.212 489.712C562.935 488.202 561.044 487.285 558.989 487.664C556.933 488.042 555.491 489.571 555.768 491.081Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M555.99 490.05C556.111 490.711 556.94 491.113 557.84 490.947C558.74 490.781 559.371 490.111 559.25 489.451C559.129 488.79 558.301 488.388 557.401 488.554C556.5 488.719 555.869 489.389 555.99 490.05Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_6328",
    x1: 837.307,
    y1: 476,
    x2: 837.307,
    y2: 525.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_6328",
    x1: 839.642,
    y1: 478.523,
    x2: 827.561,
    y2: 513.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_6328",
    x1: 837.311,
    y1: 485.729,
    x2: 831.258,
    y2: 503.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B993",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1989_6328",
    x1: 557.724,
    y1: 476,
    x2: 557.724,
    y2: 525.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1989_6328",
    x1: 555.391,
    y1: 478.523,
    x2: 567.482,
    y2: 513.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1989_6328",
    x1: 557.719,
    y1: 485.729,
    x2: 563.778,
    y2: 503.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B993",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB086"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7ExternalSpeakerSystem);
export default __webpack_public_path__ + "static/media/7ExternalSpeakerSystem.ab650f4ca3a5d95e403303e23a91f7a5.svg";
export { ForwardRef as ReactComponent };